import React from 'react';
import PropTypes from 'prop-types';

const PaymentMethodsIcons = ({showAppleAndGooglePay, showLesserUsed}) => {
    return (
        <div className="PaymentMethodsIcons">
            {showAppleAndGooglePay && (
                <>
                    <span className="card-sprite sprite-cc-apple-pay" />
                    <span className="card-sprite sprite-cc-google-pay" />
                </>
            )}
            <span className="card-sprite sprite-cc-visa" />
            <span className="card-sprite sprite-cc-mastercard" />
            <span className="card-sprite sprite-cc-amex" />
            <span className="card-sprite sprite-cc-discover" />
            {showLesserUsed && (
                <>
                    <span className="card-sprite sprite-cc-jcb" />
                    <span className="card-sprite sprite-cc-diners-club" />
                    <span className="card-sprite sprite-cc-maestro" />
                </>
            )}
        </div>
    );
};

PaymentMethodsIcons.propTypes = {
    showAppleAndGooglePay: PropTypes.bool,
    showLesserUsed: PropTypes.bool,
};

export default PaymentMethodsIcons;
